import React from "react"

import {
    Avatar,
    Box, FormControl, Grid, InputLabel, MenuItem, Select, Stack, TextField,
    Typography
} from "@mui/material"

import { t } from "@lingui/macro"
import Icon from "@mdi/react"

import { Autocomplete } from "@mui/lab"
import { Loading } from "@sinossi/mates-react-library"
import {
    AccountType,
    Action, AssignableUsers,
    WorkflowActionUtils
} from "models"
import { WorkflowService } from "services/workflow.service"
import { SbDialog } from "../../commons/sb-dialog"

interface OptionsType {
    id: string,
    name: string
}

interface AssignWorkflowActionProp {
    openDialog: boolean
    onClose: () => void
    assign: (actionId: string, userId: string) => void
    data: Action
    users: AssignableUsers[]
}
interface AssignWorkflowActionState {
    personSelected: string
    timeout: any
    userValue: any
    userInputValue: string
    userOptions: OptionsType[],
    loading: boolean
    selectedAccountType: string | null
}
export class AssignWorkflowAction extends React.Component<AssignWorkflowActionProp, AssignWorkflowActionState> {
    constructor(props: AssignWorkflowActionProp) {
        super(props)
        this.state = {
            personSelected: "",
            userValue: null,
            userInputValue: "",
            userOptions: [],
            timeout: null,
            loading: false,
            selectedAccountType: null
        }
    }

    componentDidMount() {
        this.setUserOptions(this.props.users, true)
    }

    private onClose = () => {
        this.setState(() => ({
            personSelected: "",
            selectedAccountType: null,
            userValue: null,
            userInputValue: "",
            userOptions: []
        }))
        this.props.onClose()
    }

    private assign = () => {
        if (this.state.personSelected) {
            this.props.assign(this.props.data.id, this.state.personSelected)
        }
    }

    private fetchUsers = (input: string) => {

        if (this.state.timeout) {
            clearTimeout(this.state.timeout)
        }

        this.setState(() => ({
            timeout: setTimeout(() => this.filterUsers(input), 600)
        }))
    }

    private filterUsers = (input: string) => {


        this.setState(() => ({
            loading: true
        }))

        // this.props.users.map((user) => {
        //     let userName = (user.accountDetails.firstName ?? "") + (user.accountDetails.lastName ? " " + user.accountDetails.lastName : "") + " - " + user.username
        //     if (userName.includes(input)) {
        //         newList.push(user)
        //     }
        // })


        if (input !== "") {

            WorkflowService.getAssignableUsersWithSearch(this.props.data.id, input, this.state.selectedAccountType, this.handleUserChangeCallback, () => console.log("Err"))
        }
        // this.setUserOptions(newList)
    }

    private handleUserChangeCallback = (response: any) => {

        console.log(response)

        if (response.data)
            this.setUserOptions(response.data)

        this.setState(() => ({
            loading: false
        }))
    }

    private setUserOptions = (newList: AssignableUsers[], init?: boolean) => {
        let userOptions: OptionsType[] = []

        newList.map((user) => userOptions.push(
            {
                id: user.id,
                name: (user.accountDetails.firstName ?? "") + (user.accountDetails.lastName ? " " + user.accountDetails.lastName + " - " : "") + user.username
            }
        ))

        if (init) {
            this.setState(() => ({
                userOptions: userOptions,
            }), this.setUserValue)
        }
        else {
            this.setState(() => ({
                userOptions: userOptions
            }))
        }
    }

    private setUserValue = () => {
        if (this.props.data.executor) {
            let userValue = this.state.userOptions.find((user) => {
                if (user.id === this.props.data.executor!.id) {
                    return user
                }
            })

            this.setState(() => ({
                userValue: userValue !== undefined ? userValue : null,
                userOptions: []
            }))
        }
    }

    private handleAccountTypeChange = (event: any) => {
        const newAccountType = event.target.value || null;
        this.setState(() => ({
            selectedAccountType: newAccountType,
            userValue: null,
            userInputValue: "",
            userOptions: []
        }), () => {
            // Se c'è del testo nella ricerca, riapplica il filtro
            if (this.state.userInputValue) {
                this.fetchUsers(this.state.userInputValue);
            }
        });
    }

    render() {
        let today = new Date()
        let deadline = new Date(this.props.data.deadline)
        let { userValue, userOptions } = this.state

        today.setHours(0, 0, 0, 0)
        deadline.setHours(0, 0, 0, 0)

        return (
            <>
                {this.state.loading && <Loading show />}
                {
                    this.props.data && this.props.openDialog &&
                    <SbDialog onClose={this.onClose}
                        width={"md"}
                        titleText={t({ id: "workflow.assign-workflow-action.title", message: "Assegna azione" })}
                        cancelButton
                        confirmButton
                        onConfirm={this.assign}
                    >
                        <Grid container sx={{ mt: 2 }} alignItems={"center"}>
                            <Grid item xs={1}>
                                <Avatar sx={{
                                    backgroundColor: this.props.data.status === "DONE" ?
                                        "primary.main" : (this.props.data.status === "WORKING" ?
                                            "secondary.main" : (deadline.getTime() < today.getTime() ?
                                                "error.main" : "lightgray")),
                                    width: 64,
                                    height: 64,
                                }}>
                                    <Box
                                        component={Icon}
                                        path={WorkflowActionUtils.renderIcon(this.props.data.actionType)}
                                        size="40px"
                                        sx={{
                                            color: "primary.contrastText",
                                            backgroundColor: this.props.data.status === "DONE" ?
                                                "primary.main" : (this.props.data.status === "WORKING" ?
                                                    "secondary.main" : (deadline.getTime() < today.getTime() ?
                                                        "warning.main" : "lightgray")),
                                            padding: "4px"
                                        }}>
                                    </Box>
                                </Avatar>
                            </Grid>
                            <Grid item xs={11}>
                                <Stack>
                                    <Typography sx={{ fontSize: "14pt", fontWeight: '500', lineHeight: 1 }}>
                                        {this.props.data.name}
                                    </Typography>
                                    {this.props.data.assignedActorRole === AccountType.BRAND && <Typography sx={{ fontSize: "12pt", fontWeight: '500', lineHeight: 1, mt: 2 }}>
                                        Questa azione può essere assegnata solo a utenti brand
                                    </Typography>}
                                    {this.props.data.assignedActorRole === AccountType.ADMIN && <Typography sx={{ fontSize: "12pt", fontWeight: '500', lineHeight: 1, mt: 2 }}>
                                        Questa azione può essere assegnata solo a utenti amministratori
                                    </Typography>}
                                    {this.props.data.assignedActorRole === AccountType.MICROJOB && <Typography sx={{ fontSize: "12pt", fontWeight: '500', lineHeight: 1, mt: 2 }}>
                                        Questa azione può essere assegnata solo a utenti microjobber
                                    </Typography>}
                                    {this.props.data.assignedActorRole === AccountType.LANDLORD && <Typography sx={{ fontSize: "12pt", fontWeight: '500', lineHeight: 1, mt: 2 }}>
                                        Questa azione può essere assegnata solo a utenti landlord
                                    </Typography>}
                                </Stack>
                            </Grid>
                            <Grid item xs={12}>
                                <Grid container spacing={2} sx={{ mt: 1 }}>
                                    <Grid item xs={4}>
                                        <FormControl fullWidth>
                                            <InputLabel>{t({ id: "assign-modal.filter-by-role", message: "Filtra per ruolo" })}</InputLabel>
                                            <Select
                                                value={this.state.selectedAccountType || ""}
                                                onChange={this.handleAccountTypeChange}
                                                label={t({ id: "assign-modal.filter-by-role", message: "Filtra per ruolo" })}
                                            >
                                                <MenuItem value="">
                                                    <em>{t({ id: "assign-modal.all-roles", message: "Tutti i ruoli" })}</em>
                                                </MenuItem>
                                                <MenuItem value="LANDLORD">Landlord</MenuItem>
                                                <MenuItem value="ADMIN">Amministratore</MenuItem>
                                                <MenuItem value="BRAND">Brand</MenuItem>
                                                <MenuItem value="MICROJOB">Microjobber</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <Autocomplete
                                            getOptionLabel={(option) => option.name}
                                            filterOptions={(x) => x}
                                            options={userOptions}
                                            autoComplete
                                            includeInputInList
                                            filterSelectedOptions
                                            value={userValue}
                                            noOptionsText={t({ id: "create-contract-modal.no-user", message: "Inizia a digitare per avviare la ricerca" })}
                                            onChange={(event, newValue) => {
                                                if (newValue) {
                                                    this.setState(() => ({
                                                        userValue: newValue, userOptions: [newValue, ...userOptions],
                                                        personSelected: newValue.id
                                                    }))
                                                }
                                            }}
                                            onInputChange={(event, newInputValue) => {
                                                this.setState({ userInputValue: newInputValue }, () => {
                                                    if (this.state.userInputValue === '') {
                                                        this.setState({ userOptions: userValue ? [userValue] : [] });
                                                    }
                                                    else {
                                                        this.fetchUsers(this.state.userInputValue)
                                                    }
                                                })
                                            }}
                                            renderInput={(params) => (
                                                <TextField {...params}
                                                    label={t({ id: "create-contract-modal.select-user", message: "Assegna a..." })}
                                                    fullWidth
                                                    required
                                                />
                                            )}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </SbDialog>
                }
            </>
        )
    }
}
